import { defineModule, definePermission } from '@shared/contract'

// Inventur: Zählung planen, am Telefon zählen, Differenzen prüfen, freigeben, buchen.
//
// Rechte – alle je Standort vergebbar (db/seeds/demo/roles.ts, Abschnitt „Inventur“):
//   * read     Inventuren, Fortschritt, Inventurliste und Protokoll lesen. Bei einer Blindzählung sieht den
//              Buchbestand und die Differenzen nur, wer plant oder freigibt – bis die Inventur gebucht ist.
//   * create   planen, starten, Nachzählungen anordnen, Gründe setzen, abbrechen.
//   * enter    zählen (Zählliste lesen, Zählungen einreichen) – dem Assistenten nie angeboten.
//   * approve  Differenzen freigeben und buchen, bis `maxDifferenceCents` (Summe der Beträge aller Differenzen zum
//              gleitenden Durchschnitt) – nie als einzige Person, die gezählt hat.
const GROUP = 'Lager'

export default defineModule({
  id: 'stocktaking',
  title: 'Inventur',
  description: 'Stichtags-, permanente und Kontrollzählung: Zählplan, Zählung am Telefon, Differenzen, Freigabe, Inventurliste.',
  dependsOn: ['platform', 'masterdata'],
  permissions: [
    definePermission({
      key: 'stocktaking.count.read',
      label: 'Inventuren lesen',
      group: GROUP,
      description: 'Zählpläne, Fortschritt, Inventurliste und Protokoll – an den eigenen Standorten. Buchbestand und Differenzen einer Blindzählung erst nach dem Buchen.',
    }),
    definePermission({
      key: 'stocktaking.count.create',
      label: 'Inventuren planen und leiten',
      group: GROUP,
      description: 'Zählplan anlegen und starten, Differenzen ansehen, Nachzählungen anordnen, Gründe setzen, abbrechen.',
    }),
    definePermission({
      key: 'stocktaking.count.enter',
      label: 'Zählen',
      group: GROUP,
      description: 'Zähllisten am Telefon öffnen und Zählungen einreichen.',
    }),
    definePermission({
      key: 'stocktaking.count.approve',
      label: 'Inventurdifferenzen freigeben und buchen',
      group: GROUP,
      description: 'Bucht die Differenzen zum Stichtag – bis zur Wertgrenze und nie als einzige Person, die gezählt hat.',
      limits: [{ key: 'maxDifferenceCents', label: 'Höchster Wert der Differenzen je Inventur', unit: 'cents' }],
    }),
  ],
})
